import { DisputeReviewFragmentType } from '@pay-bill/graphql';

export const hasDisputeActions = (dispute: DisputeReviewFragmentType) =>
  dispute.canAccept.value ||
  dispute.canApprove.value ||
  dispute.canEdit.value ||
  dispute.canReject.value ||
  dispute.canReopen.value ||
  dispute.canRetract.value;
